import { render } from "./PrivateItemComposer.vue?vue&type=template&id=8ab8be8c&scoped=true"
import script from "./PrivateItemComposer.vue?vue&type=script&lang=js"
export * from "./PrivateItemComposer.vue?vue&type=script&lang=js"

import "./PrivateItemComposer.vue?vue&type=style&index=0&id=8ab8be8c&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ab8be8c"]])

export default __exports__